import React from "react";
import { NotInterestedReason } from "../../messages";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import AppModal from "../Generic/AppModal/AppModal";

export type RejectVisitModalProps = {
  type: "RejectVisit";
  onClickRejectVisit: (notInterestedReason: NotInterestedReason) => void;
  onClickClose: () => void;
};

interface Props {
  isOpen: boolean;
  modalProps: RejectVisitModalProps;
}

export default function RejectVisitModal(props: Props) {
  return (
    <AppModal
      type="info"
      isOpen={true}
      title={translate(STRINGS.JUST_TO_BE_SURE)}
      message={translate(
        STRINGS.TELL_US_WHY_YOU_ARE_NOT_INTERESTED_SO_WE_CAN_SEND_YOU_BETTER_CASES
      )}
      actions={[
        {
          key: "case-is-too-far",
          variant: "soft",
          size: "small",
          color: "black",
          onClick: () => props.modalProps.onClickRejectVisit({ payload: "Case is too far" }),
          children: translate(STRINGS.CASE_IS_TOO_FAR),
        },
        {
          key: "not-enough-hours",
          variant: "soft",
          size: "small",
          color: "black",
          onClick: () => props.modalProps.onClickRejectVisit({ payload: "Not enough hours" }),
          children: translate(STRINGS.NOT_ENOUGH_HOURS),
        },
        {
          key: "too-many-hours",
          variant: "soft",
          size: "small",
          color: "black",
          onClick: () => props.modalProps.onClickRejectVisit({ payload: "Too many hours" }),
          children: translate(STRINGS.TOO_MANY_HOURS),
        },
        {
          key: "does-not-fit-my-schedule",
          variant: "soft",
          size: "small",
          color: "black",
          onClick: () =>
            props.modalProps.onClickRejectVisit({ payload: "Does not fit my schedule" }),
          children: translate(STRINGS.DOES_NOT_FIT_MY_SCHEDULE),
        },
        {
          key: "i-have-changed-my-mind",
          variant: "link",
          color: "black",
          onClick: () => props.modalProps.onClickClose(),
          children: translate(STRINGS.I_HAVE_CHANGED_MY_MIND),
        },
      ]}
    />
  );
}
